import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SubscriptionSettingsComponent } from './subscription-settings/subscription-settings.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'vault',
    pathMatch: 'full',
  },
  {
    path: 'vault',
    loadChildren: () =>
      import('./vault/vault.module').then((m) => m.VaultModule),
  },
  {
    path: 'staking',
    loadChildren: () =>
      import('./staking/staking.module').then((m) => m.StakingModule),
  },
  {
    path: 'nft-staking',
    loadChildren: () =>
      import('./nft-staking/nft-staking.module').then(
        (m) => m.NftStakingModule
      ),
  },
  {
    path: 'otc',
    loadChildren: () => import('./otc/otc.module').then((m) => m.OtcModule),
  },
  {
    path: 'info',
    loadChildren: () => import('./info/info.module').then((m) => m.InfoModule),
  },
  {
    path: 'bridge',
    loadChildren: () =>
      import('./bridge/bridge.module').then((m) => m.BridgeModule),
  },
  {
    path: 'subscription-settings',
    component: SubscriptionSettingsComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
